module.exports = __webpack_public_path__ + "IMG_3088_scaglie2.png?d72dae8ac7a6c0cfb06515dab95532c8";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/IMG_3088_scaglie2.png
// module id = 103
// module chunks = 0